import Login from './login.vue'
import auth from '@/router/middlewares/auth'

// import middlewares
export default [{
  path: '/login',
  alias: '/',
  component: Login,
  name: 'Login',
  meta: {
    middleware: {
      ignore: auth,
      attach: ({ redirect, store }) => {
        const user = store.getters['auth/user']
        if (user) {
          return redirect({
            name: 'Dashboard'
          })
        }
      }
    },
    nav: {
      display: false,
      name: 'Login'
    }
  }
}]
